import { render, staticRenderFns } from "./ContactInformation.vue?vue&type=template&id=dc0fa032&scoped=true&"
import script from "./ContactInformation.vue?vue&type=script&lang=js&"
export * from "./ContactInformation.vue?vue&type=script&lang=js&"
import style0 from "./ContactInformation.vue?vue&type=style&index=0&id=dc0fa032&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0fa032",
  null
  
)

export default component.exports